import { render, staticRenderFns } from "./SettingMarket.vue?vue&type=template&id=70a35e8c&scoped=true&"
import script from "./SettingMarket.vue?vue&type=script&lang=js&"
export * from "./SettingMarket.vue?vue&type=script&lang=js&"
import style0 from "./SettingMarket.vue?vue&type=style&index=0&id=70a35e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a35e8c",
  null
  
)

export default component.exports